export const keyCodes = {
  ENTER: "Enter",
  SPACE: " ",
  ESCAPE: "Escape",
  DOWN_ARROW: "ArrowDown",
  UP_ARROW: "ArrowUp",
  LEFT_ARROW: "ArrowLeft",
  RIGHT_ARROW: "ArrowRight",
  TAB: "Tab"
};

export const SELECTION_KEYS = [keyCodes.ENTER, keyCodes.SPACE];
export const UP_DOWN_ARROWS = [keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];
